import { create } from "../../../../../common/utils/zustand_state_manager";
import { InitializePaginationProperties, InitializeSetPaginationProperties, PaginationProperties, SetPaginationProperties } from "../../../../../common/utils/pagination_property";

/**
 * useRequisicaoServicosProdutosPagination
 */

type State = {
  requisicaoProdutosServicos: PaginationProperties,
  alteracaoRequisicaoProdutosServicos: PaginationProperties,
};

type Actions = {
  requisicaoProdutosServicosSetter: SetPaginationProperties,
  alteracaoRequisicaoProdutosServicosSetter: SetPaginationProperties,
};

export const useRequisicaoServicosProdutosPagination = create<State & Actions>((set) => ({
  requisicaoProdutosServicos: InitializePaginationProperties(),
  requisicaoProdutosServicosSetter: InitializeSetPaginationProperties(set, 'requisicaoProdutosServicos'),

  alteracaoRequisicaoProdutosServicos: InitializePaginationProperties(),
  alteracaoRequisicaoProdutosServicosSetter: InitializeSetPaginationProperties(set, 'alteracaoRequisicaoProdutosServicos'),
}));